import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Grid, Typography } from '@material-ui/core';


const ProcessBox = ({ label }) => (
  <Grid item xs={12}>
    <Box px={5} pt={3} pb={1} width="100%" display="flex" flexDirection="column" alignItems="center">
      <CircularProgress size={20} thickness={4.8} />
      <Typography variant="overline" align="center">Procesando {label}</Typography>
    </Box>
  </Grid>
);

ProcessBox.propTypes = {
  label: PropTypes.string.isRequired,
};

export {
  ProcessBox,
};